import { Component, Input } from '@angular/core';
import { SubdomainInfo } from 'app/core/models/subdomain-info';
import { User } from 'app/core/models';
import { BudgetAvailabilityType } from 'app/core/helpers/enums';

@Component({
  selector: 'app-budget-details',
  templateUrl: './budget-details.component.html',
  styleUrls: ['./budget-details.component.scss']
})
export class BudgetDetailsComponent {
  @Input() userCompanyInfo: SubdomainInfo;
  @Input() userDashboardInfo: User;
  @Input() manualLoadTransport: number;
  @Input() manualLoadProfessionalDevelopment: number;

  readonly BudgetAvailabilityType = BudgetAvailabilityType;
}
